import React, { Component } from 'react';
import { Input, Button, Form } from 'antd';
import logoSrc from '$assets/logoWithText.png';

import styles from './form.scss';

class ResetPasswordForm extends Component {
  onFinish = (values) => {
    const { token } = this.props;
    this.props.resetPassword({
      variables: {
        input: {
          ...values,
          token,
        },
      },
    });
  };

  render() {
    const { loading } = this.props;

    return (
      <Form onFinish={this.onFinish} className={styles.form}>
        <Form.Item>
          <img className={styles.logo} src={logoSrc} />
        </Form.Item>
        <div className={styles.header}>Reset password</div>
        <Form.Item
          name="email"
          rules={[{ required: true, message: 'Please input your email!' }]}
        >
          <Input
            autoComplete="username"
            prefix={<i className="fal fa-user" />}
            placeholder="Email"
          />
        </Form.Item>
        <Form.Item
          name="password"
          rules={[{ required: true, message: 'Please input your new password!' }]}
        >
          <Input
            autoComplete="new-password"
            prefix={<i className="fal fa-lock" />}
            type="password"
            placeholder="New password"
          />
        </Form.Item>
        <Form.Item>
          <Button type="primary" htmlType="submit" block loading={loading}>
            Reset password
          </Button>
        </Form.Item>
      </Form>
    );
  }
}

export default ResetPasswordForm;
